// Small, repeatable, trauma-informed actions. Tied loosely to result categories.

export const STEP_FORWARD_ACTIONS = [
  // Stabilize
  {
    id: "sf_breath",
    category: "Stabilize",
    title: "Box breathing — 4 rounds",
    body: "Inhale 4, hold 4, exhale 4, hold 4. Repeat four times. That's it.",
    minutes: 2,
    matches: ["quiet_reckoning", "coming_into_focus"],
  },
  {
    id: "sf_water",
    category: "Stabilize",
    title: "Drink a full glass of water",
    body:
      "A glass of water can be a simple way to care for your body before deciding what comes next.",
    minutes: 1,
    matches: ["quiet_reckoning", "coming_into_focus", "stepping_forward"],
  },
  {
    id: "sf_grounding",
    category: "Stabilize",
    title: "5-4-3-2-1 grounding",
    body:
      "Notice 5 things you can see, 4 you can touch, 3 you hear, 2 you smell, 1 you taste.",
    minutes: 3,
    matches: ["quiet_reckoning", "coming_into_focus"],
  },

  // Tell one truth
  {
    id: "sf_truth_note",
    category: "Truth-Telling",
    title: "Write one true sentence",
    body:
      "Open your Journal and finish: \"What I'm not saying out loud is…\" Don't edit.",
    minutes: 5,
    matches: ["coming_into_focus", "stepping_forward"],
  },
  {
    id: "sf_truth_voice",
    category: "Truth-Telling",
    title: "Say it aloud once",
    body:
      "Find a private space. Say the truthful sentence aloud. Let your body hear you.",
    minutes: 2,
    matches: ["coming_into_focus", "stepping_forward"],
  },

  // Reach out
  {
    id: "sf_text",
    category: "Connection",
    title: "Text one person something real",
    body:
      "Not 'how are you' — something honest. Even 'I've been having a hard week.' can be the whole message.",
    minutes: 3,
    matches: ["quiet_reckoning", "coming_into_focus", "stepping_forward"],
  },
  {
    id: "sf_walk_call",
    category: "Connection",
    title: "Walk-and-call a friend",
    body: "10 minutes outside, one phone call. Notice whether movement and conversation change anything for you.",
    minutes: 10,
    matches: ["stepping_forward", "rooted_reaching"],
  },

  // Reduce harm
  {
    id: "sf_pause",
    category: "Harm-Reduction",
    title: "Delay the urge by 15 minutes",
    body:
      "Whatever the impulse is, set a 15-minute timer. Don't refuse it — just delay it. Notice what changes.",
    minutes: 15,
    matches: ["quiet_reckoning", "coming_into_focus"],
  },
  {
    id: "sf_remove",
    category: "Harm-Reduction",
    title: "Remove one easy trigger",
    body:
      "Delete the app, pour out the bottle, or mute the contact. One bit of friction can create more room to choose.",
    minutes: 5,
    matches: ["coming_into_focus", "stepping_forward"],
  },

  // Repair
  {
    id: "sf_repair_apology",
    category: "Repair",
    title: "Draft a non-defensive apology",
    body:
      "Name the impact, not the intent. Don't send it yet — just write it.",
    minutes: 10,
    matches: ["stepping_forward", "rooted_reaching"],
  },
  {
    id: "sf_repair_self",
    category: "Repair",
    title: "Forgive yourself out loud",
    body:
      "Hand on chest. Say: 'I did what I could with what I knew then.' Mean it as much as you can.",
    minutes: 2,
    matches: ["coming_into_focus", "stepping_forward", "rooted_reaching"],
  },

  // Deepen
  {
    id: "sf_mentor",
    category: "Deepen",
    title: "Offer to listen",
    body:
      "Reach out to someone earlier on the path. Don't fix — just witness them today.",
    minutes: 15,
    matches: ["rooted_reaching"],
  },
  {
    id: "sf_ritual",
    category: "Deepen",
    title: "Anchor a daily 2-minute ritual",
    body:
      "Same time, same place, same intention. Repetition is the medicine.",
    minutes: 2,
    matches: ["stepping_forward", "rooted_reaching"],
  },
];

export const getActionsForCategory = (categoryId) => {
  if (!categoryId) return STEP_FORWARD_ACTIONS.slice(0, 6);
  return STEP_FORWARD_ACTIONS.filter((a) => a.matches.includes(categoryId));
};
